<template>
  <div>
    <el-input 
    :placeholder="placeholder" 
    type="number" 
    :clearable="clearable" 
    maxlength="11" 
    size="small" 
    min="1"
    max="19999999999"
    :class="className + ' phone-number-inp'" 
    @keyup.native="phoneChange"
    v-model.trim="mobile"
    :disabled="disabled">
      <template slot="append">
        <!-- @slot 在输入框尾部加icon -->
        <slot></slot>
      </template>
    </el-input>
  </div>
</template>
<script>
  /**
   * 手机号输入框，自动校验手机号格式
  * @displayName inputPhone
  */
  import { regExps } from '@/utils/reg.js';
  /**
   * 自动校验输入的数字是否符合手机号格式
   * @displayName 手机号输入框
   */
  export default {
    name: 'InputPhone',
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      /**
       * 输入提示
       */
      placeholder: {
        type: String,
        default: ''
      },
      /**
       * 是否可以一键清空
       */
      clearable: {
        type: Boolean,
        default: false
      },
      /**
       * input框的样式
       */
      className: {
        type: String,
        default: 'gc-w300'
      },
      /**
       * @model
       */
      value: {
        type: String,
        default: ''
      },
      /**
       * 是否禁用
       */
      disabled: {
        type: Boolean,
        default: false
      },
      /**
       * 是否监听 回车执行方法
       */
      isYxyEnter: {
        type: [Object, String, Function],
        default: ''
      }
    },
    data() {
      return {
        // 电话
        mobile: null
      };
    },
    watch: {
      value: {
        handler(val) {
          this.mobile = val;
        },
        deep: true,
        immediate: true
      },
      mobile: {
        handler: function(val) {
          /**
          * @ignore
          */
          this.$emit('input', val);
        },
        deep: true
      }
    },
    methods: {
      phoneChange(val) {
        let myText1 = (this.mobile).toString();
        // let textReg = /^[0-9]*$/;
        let textReg = regExps.positiveInteger;
        console.log(99, this.mobile, val.key, this.isYxyEnter, textReg.test(val.key), this.mobile.length);
        // 限制特殊字符输入
        // if (this.mobile && regExps.mobilePine.test(this.mobile) && this.isYxyEnter && val.key === 'Enter') {
        //   this.isYxyEnter();
        //   return;
        // } else if (!this.mobile && val.key === 'Enter') {
        //   // 回车不做任何处理,输入提示
        //   this.isYxyEnter();
        //   return;
        // } 
        // 不做任何校验
        if (this.isYxyEnter && val.key === 'Enter') {
          this.isYxyEnter();
          return;
        } else if (this.mobile && !textReg.test(val.key) && (val.key === '.' || val.key === '+' || val.key === '-')) {
          this.mobile = '1';
          return;
        } else if (this.mobile === '') {
          // 清空输入
          if (val.key === 'Control') {
            this.mobile = '1';
          }
          return;
        } else if (!this.mobile && val.key.length === 1) {
          this.mobile = '1';
          return;
        } else if (!textReg.test(this.mobile)) {
          this.mobile = '1';
          return;
        }
        // 1开头的11位
        if (this.mobile.length > 11) {
          // 要1开头的数字
          if (+myText1.substring(0, 1) !== 1) {
            this.mobile = '1' + myText1.slice(0, 10);
          } else {
            // 限制长度
            this.mobile = myText1.substring(0, 11);
          };
        } else if (this.mobile.length === 11) {
          // 要1开头的数字
          if (+myText1.substring(0, 1) !== 1) {
            this.mobile = '1' + myText1.substring(0, 10);
          }
        } else {
          if (this.mobile !== '' && (+myText1.substring(0, 1) !== 1)) {
            // 要1开头的数字
            this.mobile = '1' + this.mobile;
          };
        }
      }
    }
  };
</script>

